module.exports = __webpack_public_path__ + "static/img/nocome.769b77f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buttons/nocome.png
// module id = 223
// module chunks = 1